<template>
    <v-navigation-drawer stateless value="true" class="catalog-navigation" style="height: 100%;">
        <v-list class="v-list--booking" v-if="getPages.length > 0" style="height: 100%">
            <v-list-item
                :key="page.id"
                v-for="page in getPages"
                @click="editPage(page.slug)"
                :class="`v-list--booking_state f-width ${$route.params.pageSlug === page.slug ? 'active' : ''}`">
                <v-list-item-title v-text="page.title"/>
                <v-list-item-action>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn icon @click.prevent="changePageStatus(page.id, page.status)" v-on="on">
                                <v-icon>{{ page.status ? 'remove_red_eye' : 'visibility_off' }}</v-icon>
                            </v-btn>
                        </template>

                        <span>Статус</span>
                    </v-tooltip>
                </v-list-item-action>
            </v-list-item>
        </v-list>
        <empty v-else/>
    </v-navigation-drawer>
</template>

<script>
    import { mapGetters } from 'vuex'
    import Page from '../../../api/page'
    import Empty from '../../../components/Loader/Empty'

    export default {
        name: 'pageNavigation',
        components: { Empty },
        methods: {
            editPage (slug) {
                this.$router.push({
                    name: 'editPage',
                    params: { pageSlug: slug }
                })
            },
            changePageStatus (id, status) {
                Page
                    .changeStatus({
                        id,
                        status
                    })
                    .then(response => {
                        this.$store.commit('changePageState', response.data.data)
                        this.$store.commit('showSnackbar', {
                            text: 'Статус страницы изменен успешно',
                            color: 'info'
                        })
                    })
                    .catch(error => this.$store.commit('showSnackbar', { text: error.response.data.error[Object.keys(error.response.data.error)[0]][0] }))
            }
        },
        computed: mapGetters([
            'getPages'
        ])
    }
</script>
